<ng-container *ngComponentOutlet="browseByComponent | async"></ng-container>
